import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Input, CustomInput, Form, Label } from "reactstrap";
import { Dispatch } from "../../store/store";
import Symbol from "../../Fields/Symbol";
import { onChangeHeader, onChange, onChangeItem } from "../../IO";
import { LocalINTL, SimpleSuggest } from "../../Fields";
import { Field, Numeric, Combobox } from "../../../Order/Field/Field";
import { CurrencyAsset, IOMode, IOType, IOTransferType } from "../../../../IO/types";
import { commissionSuffix } from "../../../Order/Form/commons";
import Account from "../../Fields/Account";
import Files from "../../Fields/Files/Files";
import { isEmpty } from "../Default";
import { processes } from "../../../../../utils/Helper";
import { FormField, SelectFormField } from "../../../../../utils";

const Withdrawal = ({disableACSelector}) => {
  const { dispatch, services, state } = useContext(Dispatch);
  const { io, fields, entities, permissions } = state;
  const { errors, readonly } = fields;
  const { allowValues, allowCash } = permissions;
  const header = io.itemsHeader;
  const simpleItem = io.items[0];
  const [denominationsReturn, setDenominationsReturn] = useState([]);
  const [balance, setBalance] = useState({
    loading: false,
    data: [],
  });
  const [reasons, setReasons] = useState([]);
  const [denominations, setDenominations] = useState([]);
  //console.log("io", io);
  // XOR operator
  const readOnlyTypeSelector = allowValues ? !allowCash : allowCash;
  const accountEmpty = isEmpty(header.AccountId);
  const currencyEmpty = isEmpty(simpleItem.CurrencyId);
  const [assetDenominationInfo, setAssetDenominationInfo] = useState({ AssetPhysicalDenomination: false });
  const [documentTypes, setDocumentTypes] = useState([]);

  useEffect(() => {
    //get reasons
    try {
      services.fetchGetReasons({ process: processes.WITHDRAW }).then((r) => {
        r ? setReasons(r.keyValues) : "";
      });
    } catch (e) {
      setReasons([]);
    }
  }, []);

  useEffect(()=>{
    if (disableACSelector == undefined)
      disableACSelector = false
  }, []);

  useEffect(()=>{
    try {
      services.GetDocumentTypes().then((res)=>{
        const result = res.documenttypes.map((item) => ({
          id: item.DocumentTypeId,
          description: item.DocumentTypeName,
        }));
        setDocumentTypes(result)
      })
    } catch(e) {
      setDocumentTypes([]);
    }
  },[])

  useEffect(() => {
    if (header.IsCurrency && !header.BankAccountIsThirdParty) {
      if (!isEmpty(header.AccountId) && !isEmpty(simpleItem.CurrencyId)) {
        if (state.io.Status === "Filled") {
          dispatch({
            type: "UPDATE_ACCOUNT_BANKS",
            accountBanks: [
              {
                BankAccountHolders: header.BankAccountHolders,
                BankAccountId: header.BankAccountId,
                BankAccountItemId: header.BankAccountItemId,
                BankAccountName: header.BankAccountName,
                BankAccountNumber: header.BankAccountNumber,
              },
            ],
          });
        } else {
          services
            .fetchGetAccountBanks({
              accountId: header.AccountId,
              currencyId: simpleItem.CurrencyId,
            })
            .then((r) => r.response)
            .then((r) => {
              dispatch({
                type: "UPDATE_ACCOUNT_BANKS",
                accountBanks: r.accountBanks,
              });
              let item;
              if (header.BankAccountItemId === null && r.accountBanks) {
                item = r.accountBanks[0];
                onChangeHeader(dispatch, {
                  ...item,
                });
              } else {
                item = r.accountBanks.find((a) => a.BankAccountItemId === header.BankAccountItemId);
                onChangeHeader(dispatch, {
                  ...item,
                });
              }

              if (item) {
                onChangeHeader(dispatch, {
                  ThirdPartyPersonName: item.BankAccountHolders,
                });
              }
            });
        }
      } else {
        dispatch({ type: "UPDATE_ACCOUNT_BANKS", accountBanks: [] });
        onChangeHeader(dispatch, {
          BankAccountItemId: null,
          BankAccountName: null,
        });
      }
    }
  }, [header.AccountId, simpleItem.CurrencyId]);
  useEffect(() => {
    if (header.AccountId) {
      setBalance({ ...balance, loading: true });
      services.fetchAccountBuyingPower({ accountId: header.AccountId }).then((response) => {
        const { buyingpower } = response.response;
        setBalance({ ...balance, data: buyingpower });
      });
    } else {
      setBalance({ ...balance, data: [] });
    }
    setBalance({ ...balance, loading: false });
  }, [header.AccountId, header.IsCurrency]);

  useEffect(() => {
    if (header.AccountId && !header.IsCurrency && simpleItem.AssetId) {
      setBalance({ ...balance, loading: true });
      services
        .fetchAccountSellingPower({ accountId: header.AccountId, assetId: simpleItem.AssetId })
        .then((response) => {
          const { sellingpower } = response.response;
          setBalance({ ...balance, data: sellingpower });
        });
    } else {
      setBalance({ ...balance, data: [] });
    }
    setBalance({ ...balance, loading: false });
  }, [simpleItem.AssetId]);

  useEffect(() => {
    if (header.AccountId && !header.IsCurrency && simpleItem.AssetId) {
      setBalance({ ...balance, loading: true });
      services
        .fetchAccountSellingPower({ accountId: header.AccountId, assetId: simpleItem.AssetId })
        .then((response) => {
          const { sellingpower } = response.response;
          setBalance({ ...balance, data: sellingpower });
        });
    } else {
      setBalance({ ...balance, data: [] });
    }
    setBalance({ ...balance, loading: false });
    services.fetchGetAssetInformation({ assetId: simpleItem.AssetId }).then((response) => {
      if (response.info.AssetPhysicalDenomination) {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: response.info.AssetPhysicalDenomination,
          AssetSheetSize: response.info.AssetSheetSize,
          SlotsQuantity: 0,
        });
      } else {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: false,
          AssetSheetSize: 0,
          SlotsQuantity: 0,
        });
      }
      //console.log("response:", response.info);
      //setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
    });
  }, [simpleItem.AssetId]);

  //check slots quantity if the quantity changes
  useEffect(() => {
    //console.log(io);
    if (assetDenominationInfo.AssetPhysicalDenomination && simpleItem.Quantity) {
      let slots = Math.ceil(simpleItem.Quantity / assetDenominationInfo.AssetSheetSize);
      setAssetDenominationInfo({
        ...assetDenominationInfo,
        SlotsQuantity: slots,
      });
      let i;
      if (slots > denominationsReturn.length) {
        //selecciono menos denominations de los marcados en cantidad
        i = false;
      } else if (slots < denominationsReturn.length) {
        //seleciono mas denominations de los marcados en cantidad
        i = false;
      } else {
        i = true;
      }

      onChange(dispatch, {
        denominationsTrue: i,
        slots: slots,
      });
    }
  }, [simpleItem.Quantity, denominationsReturn.length]);

  const onChangeDenomination = (checked, value, index) => {
    let denominationResult = denominationsReturn;
    if (checked) {
      denominationsReturn.push({ key: index, DenominationId: value });
    } else {
      const updatedDenomination = denominationsReturn.filter((item) => item.key !== index);
      setDenominationsReturn(updatedDenomination);
      denominationResult = updatedDenomination;
    }
    onChangeItem(dispatch, simpleItem.Id, {
      Denominations: denominationResult,
    });
  };
  useEffect(() => {
    //console.log(simpleItem.AssetId, header.AccountId);
    //console.log(io);
    if (io.Id == undefined) {
      services
        .GetDenominations({
          AssetId: simpleItem.AssetId,
          AccountId: header.AccountId,
          WithdrawId: 0,
          DepositId: 0,
          itemId: 0,
          TransferId: 0,
        })
        .then((response) => {
          //console.log("sin id");
          const responseDenominations = response.denominations;
          //console.log(responseDenominations);
          setDenominations(responseDenominations);
          onChange(dispatch, {
            DenominationsTotal: responseDenominations,
            slots: 0,
          });
        });
    } else {
      services
        .GetDenominations({
          AssetId: simpleItem.AssetId,
          AccountId: header.AccountId,
          WithdrawId: io.Id,
          DepositId: -1,
          itemId: 0,
          TransferId: -1,
        })
        .then((response) => {
          //console.log("con id");
          const responseDenominations = response.denominations;
          //console.log(responseDenominations);
          setDenominations(responseDenominations);
          onChange(dispatch, {
            DenominationsTotal: responseDenominations,
          });
        });
    }
  }, [simpleItem.AssetId, header.AccountId]);

  const checkSettlementDate = (tradedate, SimpleItemId, values) => {
    let settlementvalue = 1;
    let AssetId = 0;
    let inchange = false;
    onChange(dispatch, { Date: tradedate });
    // Disparar el onChangeItem
    if (SimpleItemId && values) {
      //console.table("Me entro al if", values);
      onChangeItem(dispatch, SimpleItemId, values);
      inchange = true;
    }

    if (header.IsCurrency === false) {
      if (inchange) {
        //console.table("True inchange:", values);
        AssetId = values.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      } else {
        //console.table("False inchange:", values);
        AssetId = simpleItem.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      }
    } else {
      settlementvalue = 1;
      AssetId = 0;
      executeSettlement(AssetId, settlementvalue, tradedate);
    }
  };

  const executeSettlement = (Asset, settlementvalue, tradedate) => {
    const getdata = {
      tradedate: tradedate,
      assetId: Asset,
      ist0: false,
      settlement: settlementvalue,
    };
    services
      .GetIOSettlementDate(getdata)
      .then((r) => onChange(dispatch, { SettlementDate: r.settlementday }));
  };

  return (
    <Container>
      <Row>
        {/* Left */}
        <Col xs={12} lg={6}>
          <Row className="mb-2" style={{ marginTop: "22px" }}>
            <Col lg={6} xs={12}>
              <LocalINTL
                isLocal={io.Local}
                readonly={readonly.Local}
                onChange={(v) => onChange(dispatch, v)}
              />
            </Col>
            <Col lg={6} xs={12}>
              <Combobox
                darken
                disabled={readonly.header_IsCurrency || readOnlyTypeSelector || disableACSelector}
                onChange={(v) =>
                  onChangeHeader(dispatch, {
                    IsCurrency: v == CurrencyAsset.Cash,
                  })
                }
                value={header.IsCurrency ? CurrencyAsset.Cash : CurrencyAsset.Asset}
                items={Object.values(CurrencyAsset).map((key, index) => ({
                  id: key,
                  description: key,
                }))}
              />
            </Col>
          </Row>

          {/* ##### Symbol ###### */}
          <Symbol
            ioType={IOType.Withdraw}
            accountId={header.AccountId}
            isCurrency={header.IsCurrency}
            onChange={(values) => checkSettlementDate(io.Date, simpleItem.Id, values)} //onChangeItem(dispatch, simpleItem.Id, values)
            error={header.IsCurrency ? errors.simple_CurrencyISO : errors.simple_AssetTicker}
            disabled={header.IsCurrency ? readonly.header_CurrencyISO : readonly.header_AssetTicker}
            value={header.IsCurrency ? header.CurrencyISO : header.AssetTicker}
            fetchSearchSymbol={services.fetchSearchSymbol}
          />

          {/* ##### Quantity ###### */}
          <Field label={"Quantity"} error={errors.simple_Quantity}>
            <Numeric
              value={simpleItem.Quantity}
              placeholder={"Quantity"}
              onChange={(v) => onChangeItem(dispatch, simpleItem.Id, { Quantity: v })}
              invalid={!!errors.simple_Quantity}
              disabled={readonly.simple_Quantity}
              dataTypeDecimalName="quantity"
            />
          </Field>

          {/* ##### Date ##### */}
          <Field label={"Date"} error={errors.Date}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Date"}
              disabled={readonly.Date}
              value={io.Date}
              invalid={!!errors.Date}
              onChange={(e) => {
                checkSettlementDate(e.target.value);
              }}
            />
          </Field>

          {/* ##### Settlement Date ##### */}
          <Field label={"Settlement Date"} error={errors.SettlementDate}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Settlement Date"}
              disabled={readonly.SettlementDate}
              value={io.SettlementDate}
              invalid={!!errors.SettlementDate}
              onChange={(e) => onChange(dispatch, { SettlementDate: e.target.value })}
            />
          </Field>

          {reasons.length > 0 && (
            <Field label={"Reason"} error={errors.ReasonId}>
              <Input
                tabIndex="3"
                type="select"
                placeholder={"Reason"}
                disabled={readonly.ReasonId}
                value={io.ReasonId}
                invalid={!!errors.ReasonId}
                onChange={(e) =>
                  onChange(dispatch, {
                    ReasonDescription: e.target.options[e.target.selectedIndex].text,
                    ReasonId: +e.target.value,
                  })
                }
              >
                <option value="">Select a reason</option>
                {reasons.map((reason) => (
                  <option value={+reason.key}>{reason.value}</option>
                ))}
              </Input>
            </Field>
          )}
        </Col>

        {/* Right */}
        <Col xs={12} lg={6}>
          {/* ##### Account ###### */}
          <Account
            AccountId={header.AccountId}
            AccountName={header.AccountName}
            AccountNumber={header.AccountNumber}
            HolderId={header.HolderId}
            HolderName={header.HolderName}
            onChange={(values) => onChangeHeader(dispatch, values)}
            balance={balance}
            readonly={{
              AccountNumber:readonly.header_AccountNumber,
              AccountName: readonly.header_AccountName,
              HolderName: readonly.header_HolderName,
            }}
            errors={{
              AccountNumber: errors.header_AccountNumber,
              AccountName: errors.header_AccountName,
              HolderName: errors.header_HolderName,
            }}
            services={{
              fetchAccountHolders: services.fetchAccountHolders,
              fetchSearchAccount: services.fetchSearchAccount,
            }}
          />

          <Files
            id={io.Id}
            ioType={io.IOType}
            readonly={readonly.simple_Quantity}
            dispatch={dispatch}
            files={io.files}
            downloadFile={services.fetchDownloadIOFile}
          />

          {header.IsCurrency && io.Local && (
            <React.Fragment>
              <Field label={"Type"} error={errors.header_TransferType}>
                <Combobox
                  value={header.TransferType}
                  items={[
                    { id: "Transfer", description: "Transfer" },
                    { id: "Cash", description: "Cash" },
                    { id: "Cheque", description: "Cheque" },
                  ]}
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_TransferType}
                  onChange={(v) => onChangeHeader(dispatch, { TransferType: v })}
                  emptyLabel={"Type"}
                />
              </Field>

              {/* ##### Bank Account ##### */}
              {header.TransferType === IOTransferType.Transfer && (
                <React.Fragment>
                  <div className="mt-2 mb-2">
                    <CustomInput
                      label="Third party bank account"
                      type="checkbox"
                      id={`cbox-thirdParty`}
                      checked={header.BankAccountIsThirdParty || false}
                      disabled={readonly.header_BankAccountIsThirdParty}
                      onChange={(v) =>
                        onChangeHeader(dispatch, {
                          BankAccountIsThirdParty: !header.BankAccountIsThirdParty,
                          ThirdPartyDocumentTypeId: documentTypes[0].id, 
                          ThirdPartyDocumentType: documentTypes[0].description,
                        })
                      }
                    />
                  </div>
                  {header.BankAccountIsThirdParty ? (
                    <React.Fragment>
                      <SimpleSuggest
                        label={"Third party bank"}
                        service={services.fetchSearchCustodianEntity}
                        error={errors.header_BankAccountName}
                        disabled={readonly.simple_Quantity}
                        value={header.BankAccountName || ""}
                        onChange={({ id, name }) =>
                          onChangeHeader(dispatch, {
                            BankAccountId: id,
                            BankAccountName: name,
                          })
                        }
                      />

                      <Field label={"Third party bank account"} error={errors.header_BankAccountNumber}>
                        <Input
                          type={"text"}
                          placeholder={"Account"}
                          value={header.BankAccountNumber || ""}
                          invalid={errors.header_BankAccountNumber}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              BankAccountNumber: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                        />
                      </Field>

                      <Field label={"Third party person name"} error={errors.header_ThirdPartyPersonName}>
                        <Input
                          type={"text"}
                          placeholder={"Person Name"}
                          value={header.ThirdPartyPersonName || ""}
                          invalid={errors.header_ThirdPartyPersonName}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              ThirdPartyPersonName: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                        />
                      </Field>
                      <Field
                        label={"Third party document type"}
                        error={errors.header_ThirdPartyDocumentType}
                      >
                        <Combobox
                          value={(header.ThirdPartyDocumentTypeId) || ""}
                          items={documentTypes}
                          disabled={readonly.header_Quantity}
                          invalid={!!errors.header_ThirdPartyDocumentType}
                          onChange={(v) => {
                            const name = documentTypes.find(item => item.id === v);
                            onChangeHeader(dispatch, { ThirdPartyDocumentTypeId: v, ThirdPartyDocumentType: name.description})}}
                          emptyLabel={"Document Type"}
                        />
                      </Field>
                      <Field
                        label={"Third party address or identification number"}
                        error={errors.header_ThirdPartyIdentificationNumber}
                      >
                        <Input
                          type={"text"}
                          placeholder={"Third party address or identification number"}
                          value={header.ThirdPartyIdentificationNumber || ""}
                          invalid={errors.header_ThirdPartyIdentificationNumber}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              ThirdPartyIdentificationNumber: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                        />
                      </Field>

                      <SimpleSuggest
                        label={"Third party Country"}
                        service={services.fetchSearchCountry}
                        error={errors.header_ThirdPartyCountryName}
                        disabled={readonly.header_Quantity}
                        value={header.ThirdPartyCountryName}
                        onChange={({ id, name }) => {
                          onChangeHeader(dispatch, {
                            ThirdPartyCountryId: id,
                            ThirdPartyCountryName: name,
                          });
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <div>
                      <Field
                        label={"Bank Account"}
                        error={errors.header_BankAccountName}
                        description={
                          accountEmpty || currencyEmpty ? "First select an account and currency" : null
                        }
                      >
                        <Combobox
                          value={header.BankAccountItemId == 0 ? undefined : header.BankAccountItemId}
                          items={entities.accountBanks.map((a) => ({
                            id: a.BankAccountItemId,
                            description: `${a.BankAccountName} - ${a.BankAccountNumber}`,
                          }))}
                          disabled={accountEmpty || currencyEmpty || readonly.header_Quantity}
                          invalid={!!errors.header_BankAccountName}
                          onChange={(id) =>
                            onChangeHeader(dispatch, {
                              ThirdPartyPersonName: entities.accountBanks.find(
                                (a) => a.BankAccountItemId == id
                              ).BankAccountHolders,
                              ...entities.accountBanks.find((a) => a.BankAccountItemId == id),
                            })
                          }
                          emptyLabel={"Bank Account"}
                        />
                      </Field>
                      {header.BankAccountItemId && (
                        <Field label={"Bank Account Holders"}>
                          <div />
                          {header.BankAccountHolders}
                        </Field>
                      )}
                    </div>
                  )}
                </React.Fragment>
              )}

              {/* ##### Cheque ##### */}
              {header.TransferType === IOTransferType.Cheque && (
                <React.Fragment>
                  <SimpleSuggest
                    label={"Bank"}
                    service={services.fetchSearchCustodianEntity}
                    error={errors.header_BankAccountName}
                    disabled={readonly.simple_Quantity}
                    value={header.BankAccountName || ""}
                    onChange={({ id, name }) =>
                      onChangeHeader(dispatch, {
                        BankAccountId: id,
                        BankAccountName: name,
                      })
                    }
                  />

                  <Field label={"#Cheque"} error={errors.header_ChequeNumber}>
                    <Input
                      type={"text"}
                      placeholder={"Number"}
                      value={header.ChequeNumber || ""}
                      invalid={errors.header_ChequeNumber}
                      onChange={(e) =>
                        onChangeHeader(dispatch, {
                          ChequeNumber: e.target.value,
                        })
                      }
                      disabled={readonly.header_Quantity}
                    />
                  </Field>
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          <Row>
            {/* ##### Commission ###### */}
            <Col lg={6}>
              <Field label={"Commission"} error={errors.header_Commission}>
                <Numeric
                  value={header.Commission}
                  placeholder={`Commission`}
                  disabled={readonly.header_Commission}
                  onChange={(v) => onChangeHeader(dispatch, { Commission: v })}
                  invalid={!!errors.header_Commission}
                  {...commissionSuffix(null)}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.header_CommissionType}>
                <Combobox
                  value={header.CommissionType}
                  items={[
                    { id: "FaceValueCash", description: "$ Cash" },
                    { id: "PrincipalPercentage", description: "% Principal" },
                  ]}
                  disabled={readonly.header_CommissionType}
                  invalid={!!errors.header_CommissionType}
                  onChange={(v) => onChangeHeader(dispatch, { CommissionType: v })}
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        </Col>
      </Row>

      {!io.Local && (
        <React.Fragment>
          <Row>
            <Col lg={6} xs={12} />
            <Col lg={6} xs={12}>
              <div className="mt-2 mb-2">
                <CustomInput
                  label="Third party bank account"
                  type="checkbox"
                  id={`cbox-thirdParty`}
                  checked={header.BankAccountIsThirdParty || false}
                  disabled={readonly.header_BankAccountIsThirdParty}
                  onChange={(v) =>
                    onChangeHeader(dispatch, {
                      BankAccountIsThirdParty: !header.BankAccountIsThirdParty,
                    })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              {/* ##### Account ###### */}
              <Field label={"#Account"} error={errors.header_BankAccountNumber}>
                <Input
                  type={"text"}
                  placeholder={"#Account"}
                  value={header.BankAccountNumber || ""}
                  invalid={errors.header_BankAccountNumber}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      BankAccountNumber: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                />
              </Field>

              {/* ##### Bank ###### */}
              <Field label={"Bank"} error={errors.header_BankAccountName}>
                <Input
                  type={"text"}
                  placeholder={"Bank"}
                  value={header.BankAccountName || ""}
                  invalid={errors.header_BankAccountName}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      BankAccountName: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                />
              </Field>

              {/* ##### Intermediary Bank ###### */}
              <Field label={"Intermediary Bank"} error={errors.header_IntermediaryBank}>
                <Input
                  type={"text"}
                  placeholder={"Intermediary Bank"}
                  value={header.IntermediaryBank || ""}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      IntermediaryBank: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_IntermediaryBank}
                />
              </Field>
            </Col>

            <Col lg={6} xs={12}>
              {/* ##### Country ###### */}
              <SimpleSuggest
                label={"Country"}
                service={services.fetchSearchCountry}
                error={errors.header_CountryName}
                disabled={readonly.header_Quantity}
                value={header.CountryName}
                onChange={({ id, name }) => {
                  onChangeHeader(dispatch, {
                    CountryId: id,
                    CountryName: name,
                  });
                }}
              />

              {/* ##### ABA/SWIFT ###### */}
              <Field label={"ABA/SWIFT"} error={errors.header_ABASWIFT}>
                <Input
                  type={"text"}
                  placeholder={"ABA/SWIFT"}
                  value={header.ABASWIFT || ""}
                  onChange={(e) => onChangeHeader(dispatch, { ABASWIFT: e.target.value })}
                  invalid={!!errors.header_ABASWIFT}
                  disabled={readonly.header_Quantity}
                />
              </Field>

              {/* ##### Intermediary ABA/SWIFT ###### */}
              <Field label={"Intermediary ABA/SWIFT"} error={errors.header_IntermediaryABASwift}>
                <Input
                  type={"text"}
                  placeholder={"Intermediary ABA/SWIFT"}
                  value={header.IntermediaryABASwift || ""}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      IntermediaryABASwift: e.target.value,
                    })
                  }
                  invalid={!!errors.header_IntermediaryABASwift}
                  disabled={readonly.header_Quantity}
                />
              </Field>
            </Col>
          </Row>
          {header.BankAccountIsThirdParty && (
            <Row>
              <Col lg={6} xs={12}>
                <Field label={"Third party person name"} error={errors.header_ThirdPartyPersonName}>
                  <Input
                    type={"text"}
                    placeholder={"Person Name"}
                    value={header.ThirdPartyPersonName || ""}
                    invalid={errors.header_ThirdPartyPersonName}
                    onChange={(e) =>
                      onChangeHeader(dispatch, {
                        ThirdPartyPersonName: e.target.value,
                      })
                    }
                    disabled={readonly.header_Quantity}
                  />
                </Field>
              </Col>
              <Col lg={6} xs={12}>
                <Field
                  label={"Third party address or identification number"}
                  error={errors.header_ThirdPartyIdentificationNumber}
                >
                  <Input
                    type={"text"}
                    placeholder={"Third party address or identification number"}
                    value={header.ThirdPartyIdentificationNumber || ""}
                    invalid={errors.header_ThirdPartyIdentificationNumber}
                    onChange={(e) =>
                      onChangeHeader(dispatch, {
                        ThirdPartyIdentificationNumber: e.target.value,
                      })
                    }
                    disabled={readonly.header_Quantity}
                  />
                </Field>
              </Col>
            </Row>
          )}
        </React.Fragment>
      )}
      <Field>
        {assetDenominationInfo.AssetPhysicalDenomination && (
          <div style={{ width: "100%" }}>
            <div style={{ display: "flex" }}>
            <Field
              noLabel
              style={{ fontSize: "15px", fontWeight: "bold" }}
              //error={errors.simple_Denominations}
            >
              Denominations
            </Field>{" "}
            {!io.denominationsTrue && <Field noLabel error={errors.simple_Denominations}></Field>}
            </div>
            <hr style={{ border: "1px solid #ccc" }} />
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Row className="align-items-center mb-3">
              {denominations.map((denomination, key) => (
                  <Col key={key} md={6}>
                  <div className="d-flex align-items-center">
                    {io.Id === undefined && (
                      <Input
                        type="checkbox"
                        style={{
                          position: "relative",
                          cursor: "pointer",
                          marginLeft: "0rem",
                          margin: 0,
                        }}
                        onChange={(e) => {
                          onChangeDenomination(e.target.checked, denomination.DenominationId, key);
                        }}
                      />
                    )}
                  <Label className="ml-2" style={{marginBottom: 0, marginLeft: "8px"}}>{denomination.DenominationId}</Label>
                  </div>
                  </Col>
              ))}
            </Row>
            </div>
          </div>
        )}
      </Field>
    </Container>
  );
};

export const WithdrawalValidations = (io) => {
  const header = io.itemsHeader;
  const isBulk = io.IOMode == IOMode.MultipleAssets;
  const isThirdPartyAccount =
    header.TransferType == IOTransferType.Transfer && header.BankAccountIsThirdParty;

  if (isBulk) {
    return {
      form: {},
      simple: {},
      subForm: {
        AccountName: { empty: false },
        AccountNumber: { empty: true },
        HolderName: { empty: true },
        BankAccountItemId: {
          empty:
            io.Local &&
            header.IsCurrency &&
            header.TransferType == IOTransferType.Transfer &&
            !isThirdPartyAccount,
        },
        BankAccountId: {
          empty:
            io.Local &&
            header.IsCurrency &&
            ((header.TransferType == IOTransferType.Transfer && isThirdPartyAccount) ||
              header.TransferType == IOTransferType.Cheque),
        },
        BankAccountName: {
          empty: !io.Local,
        },
        ChequeNumber: {
          empty: io.Local && header.IsCurrency && header.TransferType == IOTransferType.Cheque,
        },
        BankAccountNumber: {
          empty: (header.IsCurrency && header.TransferType == IOTransferType.Transfer) || !io.Local,
        },

        IntermediaryBank: { empty: !io.Local },
        CountryName: { empty: !io.Local },
        ABASWIFT: { empty: !io.Local },
        IntermediaryABASwift: { empty: !io.Local },
      },
    };
  }

  return {
    form: {},
    simple: {
      Quantity: { empty: true },
      AssetTicker: {
        empty: header.IsCurrency == false,
        autosuggestId: "AssetId",
      },
      CurrencyISO: {
        empty: header.IsCurrency == true,
        autosuggestId: "CurrencyId",
      },
      Denominations: { DenominationsSlots: io.denominationsTrue, slots: io.slots },
    },
    subForm: {
      AccountName: { empty: false },
      AccountNumber: { empty: true },
      HolderName: { empty: true },
      BankAccountItemId: {
        empty:
          io.Local &&
          header.IsCurrency &&
          header.TransferType == IOTransferType.Transfer &&
          !isThirdPartyAccount,
      },
      BankAccountName: {
        empty: header.IsCurrency && header.TransferType == IOTransferType.Transfer,
      },
      BankAccountId: {
        empty:
          io.Local &&
          header.IsCurrency &&
          ((header.TransferType == IOTransferType.Transfer && isThirdPartyAccount) ||
            header.TransferType == IOTransferType.Cheque),
      },
      BankAccountNumber: {
        empty: !io.Local || (header.IsCurrency && header.TransferType == IOTransferType.Transfer),
      },
      ChequeNumber: {
        empty: io.Local && header.IsCurrency && header.TransferType == IOTransferType.Cheque,
      },
      // IntermediaryBank: {empty: !io.Local},
      CountryName: { empty: !io.Local },
      ABASWIFT: { empty: !io.Local },
      // IntermediaryABASwift: {empty: !io.Local},
      // ThirdPartyPersonName: {
      //   empty:
      //     (io.Local &&
      //       header.IsCurrency &&
      //       header.TransferType == IOTransferType.Transfer &&
      //       isThirdPartyAccount) ||
      //     (header.IsCurrency && !io.Local)
      // },
      // ThirdPartyIdentificationNumber: {
      //   empty:
      //     (io.Local &&
      //       header.IsCurrency &&
      //       header.TransferType == IOTransferType.Transfer &&
      //       isThirdPartyAccount) ||
      //     (header.IsCurrency && !io.Local)
      // },
      ThirdPartyCountryName: {
        empty:
          io.Local &&
          header.IsCurrency &&
          header.TransferType == IOTransferType.Transfer &&
          isThirdPartyAccount,
      },
    },
  };
};

export default Withdrawal;
